import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { IoIosArrowBack } from 'react-icons/io';
import Webcam from 'react-webcam';
import ProgressBar from '../components/ProgressBar';
import { useUser } from '../context/useInfo';
import amplitude from '../utils/amplitude';

export default function Page36() {
  const [showCamera, setShowCamera] = useState(false);
  const webcamRef = useRef(null);
  const [cameraReady, setCameraReady] = useState(false);
  const navigate = useNavigate();
  const { updateUserData } = useUser();

  const isMobile = window.innerWidth <= 768;

  // Обновляем CSS переменную --vh под реальную высоту экрана
  useEffect(() => {

    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

        if(process.env.NODE_ENV === "production"){
              amplitude.track('Take a Selfie Open');
            }
    setVH();
    window.addEventListener('resize', setVH);
    return () => window.removeEventListener('resize', setVH);
  }, []);

  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    updateUserData({ photo: imageSrc });
    localStorage.setItem("photo", imageSrc)
    if(process.env.NODE_ENV === "production") {
      amplitude.track('Take a Selfie');
      amplitude.track('Photo Button Click');
    }
    navigate('/analyze', { state: { photo: imageSrc } });
  };

  const stepBack = () => {
    updateUserData({ photo: '' });
    navigate('/quiz35');
  };

  const handleOpenCamera = () => {
  setShowCamera(true);
  if (process.env.NODE_ENV === "production") {
    amplitude.track('Take a Selfie Next');
  }
};

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.3 }}
      className="w-screen h-[calc(var(--vh,1vh)*100)] flex justify-center items-center overflow-hidden"
    >
      <div className="relative w-full max-w-[450px] h-full flex flex-col">
        {/* Верхняя панель */}
        <div className="flex items-center space-x-2 p-4 z-20 flex-shrink-0">
          <button className="text-gray-600" onClick={stepBack}>
            <IoIosArrowBack size={24} />
          </button>
          <ProgressBar />
        </div>

        {/* Фоновое изображение */}
        <img
          src={'/img36.png'}
          alt="Skincare"
          className="absolute top-0 left-0 w-full h-full object-cover"
          draggable={false}
        />

        {/* Нижняя панель */}
        <div className="absolute bottom-0 w-full bg-gradient-to-t from-black/80 to-transparent text-white px-6 py-8 text-center flex flex-col items-center space-y-4 z-20">
          <h2 className="text-2xl font-semibold">
            Let’s analyze your skin with a well-lit selfie
          </h2>
          <div className="flex items-center space-x-2 text-sm">
            <img src="/img36-1.svg" alt="Icon" className="w-5 h-5" />
            <p>It is safe! Your selfie won’t be visible to anyone</p>
          </div>

          {!showCamera ? (
            <button
              className="bg-white w-full max-w-xs text-black py-3 rounded-full font-semibold hover:bg-pink-600 hover:text-white transition"
              onClick={handleOpenCamera}
            >
              Take a selfie
            </button>
          ) : isMobile ? (
            <div
              className="fixed inset-0 z-50 bg-black flex flex-col items-center justify-center"
              style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
            >
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={{ facingMode: 'user' }}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 mb-2 w-full px-4 pb-[env(safe-area-inset-bottom)]">
                <button
                  className="bg-white text-black w-full py-3 rounded-full font-semibold hover:bg-pink-600 hover:text-white transition"
                  onClick={capturePhoto}
                >
                  Capture Photo
                </button>
              </div>
            </div>
          ) : (
            <>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={{ facingMode: 'user' }}
                onUserMedia={() => setCameraReady(true)}
                className="rounded-lg shadow-md w-72 h-72 mb-4 mx-auto"
              />
              <button
                className="bg-white w-full max-w-xs text-black py-3 rounded-full font-semibold hover:bg-pink-600 hover:text-white transition mx-auto"
                onClick={capturePhoto}
                disabled={!cameraReady}
              >
                {cameraReady ? "Photo" : "Loading..."}
              </button>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
}
